import(/* webpackMode: "eager" */ "/home/runner/work/wsp-cast-sender/wsp-cast-sender/app/page.tsx");
